/*
Copyright 2024 New Vector Ltd.
Copyright 2020 The Matrix.org Foundation C.I.C.

SPDX-License-Identifier: AGPL-3.0-only OR GPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE files in the repository root for full details.
*/

import React from "react";

import SetupEncryptionBody from "../../../structures/auth/SetupEncryptionBody";
import BaseDialog from "../BaseDialog";

interface IProps {
    onFinished(): void;
}

export default class SetupEncryptionDialog extends React.Component<IProps> {
    public constructor(props: IProps) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <BaseDialog onFinished={this.props.onFinished} fixedWidth={false}>
                <SetupEncryptionBody onFinished={this.props.onFinished} />
            </BaseDialog>
        );
    }
}
